"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionsWidget = SectionsWidget;
const jsx_runtime_1 = require("react/jsx-runtime");
require("./styles.scss");
const react_1 = require("react");
const cache_1 = require("./cache");
const SectionRow_1 = require("./SectionRow");
const Autocomplete_1 = require("./Autocomplete");
const utils_1 = require("./utils");
function handleKeyboardNav(ev) {
    var _a, _b;
    const { currentTarget } = ev;
    switch (ev.key) {
        case 'Escape':
            currentTarget.querySelector('.form-control').focus();
            break;
        case 'ArrowDown':
            if (!((_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.classList.contains('section-row'))) {
                const firstFocusTarget = currentTarget.querySelector('.section-row');
                if (!firstFocusTarget) {
                    return;
                }
                firstFocusTarget.focus();
                firstFocusTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
                return;
            }
            const nextSibling = document.activeElement.nextElementSibling;
            if (nextSibling && nextSibling.classList.contains('section-row')) {
                nextSibling.focus();
                nextSibling.scrollIntoView({ behavior: 'smooth', block: 'center' });
                return;
            }
            break;
        case 'ArrowUp':
            const prevSibling = (_b = document.activeElement) === null || _b === void 0 ? void 0 : _b.previousElementSibling;
            if (prevSibling && prevSibling.classList.contains('section-row')) {
                prevSibling.focus();
                prevSibling.scrollIntoView({ behavior: 'smooth', block: 'center' });
                return;
            }
            break;
    }
}
function SectionsWidget(props) {
    const [shouldShow, setShouldShow] = (0, react_1.useState)(false);
    const [value, setValue] = (0, react_1.useState)('');
    const [debouncedSearchTerm, setDebouncedSearchTerm] = (0, react_1.useState)('');
    const [cache] = (0, cache_1.useCache)();
    (0, react_1.useEffect)(() => {
        function handleClick() {
            setShouldShow(false);
        }
        document.addEventListener('click', handleClick);
        return () => {
            document.removeEventListener('click', handleClick);
        };
    }, []);
    (0, react_1.useEffect)(() => {
        const timeout = setTimeout(() => setDebouncedSearchTerm(value), 300);
        return () => clearTimeout(timeout);
    }, [value]);
    return ((0, jsx_runtime_1.jsxs)("div", { onKeyUp: handleKeyboardNav, onKeyDown: (ev) => {
            if (ev.key === 'ArrowUp' || ev.key === 'ArrowDown') {
                ev.preventDefault();
            }
        }, onClick: e => {
            e.stopPropagation();
            setShouldShow(true);
        }, children: [(0, jsx_runtime_1.jsx)("input", { onClick: () => {
                    cache._fetchTopLevelSections();
                    setShouldShow(true);
                }, type: "text", className: "form-control", onChange: (e) => setValue(e.target.value), value: value, placeholder: "Vyhledejte sekci", onFocus: () => {
                    setShouldShow(true);
                    setValue('');
                } }), (0, jsx_runtime_1.jsx)(utils_1.WidgetPropsProvider, { value: Object.assign(Object.assign({}, props), { hide: () => setShouldShow(false), show: () => setShouldShow(true) }), children: shouldShow && (0, jsx_runtime_1.jsx)(WidgetPopover, { searchTerm: debouncedSearchTerm }) })] }));
}
const WidgetPopover = (0, react_1.memo)(({ searchTerm }) => {
    const topLevel = (0, cache_1.useCache)('topLevelSections');
    return ((0, jsx_runtime_1.jsxs)("div", { className: "autocomplete-window", children: [!searchTerm && topLevel.map((section, i) => ((0, jsx_runtime_1.jsx)(SectionRow_1.SectionRow, { section: section, hasSubsections: !!section.has_subsections }, `t${section.id}-${i}`))), !!searchTerm && (0, jsx_runtime_1.jsx)(Autocomplete_1.AutocompleteSections, { searchTerm: searchTerm })] }));
});
